<div class="d-flex align-items-center">
  <span class="line"></span>
  <div class="circle">{{ code }}</div>
  <span class="line"></span>
</div>
